(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ready2-review-marquee"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initReviews = (root) => {
    root.querySelectorAll('[data-cro-reviews]').forEach(section => {
      if (section.dataset.initialized) return;
      const viewport = section.querySelector('[data-cro-review-viewport]');
      const cards = [...section.querySelectorAll('[data-cro-review-card]')];
      const previous = section.querySelector('[data-cro-review-previous]');
      const next = section.querySelector('[data-cro-review-next]');
      const position = section.querySelector('[data-cro-review-position]');
      if (!viewport || !cards.length || !previous || !next || !position) return;
      section.dataset.initialized = 'true';
      const offsets = () => cards.map(card => card.offsetLeft - cards[0].offsetLeft);
      const currentIndex = () => {
        const positions = offsets();
        return positions.reduce((best, value, index) => Math.abs(value - viewport.scrollLeft) < Math.abs(positions[best] - viewport.scrollLeft) ? index : best, 0);
      };
      const update = () => {
        const maximum = viewport.scrollWidth - viewport.clientWidth;
        previous.disabled = viewport.scrollLeft <= 2;
        next.disabled = viewport.scrollLeft >= maximum - 2;
        position.textContent = `${currentIndex() + 1} / ${cards.length}`;
      };
      const move = (direction) => {
        const index = Math.max(0, Math.min(cards.length - 1, currentIndex() + direction));
        viewport.scrollTo({left: offsets()[index], behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      viewport.addEventListener('scroll', update, {passive: true});
      new ResizeObserver(update).observe(viewport);
      update();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initReviews(document));
  else initReviews(document);
  document.addEventListener('shopify:section:load', event => initReviews(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
